if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

     async onSubmitHandler(evt) {
       evt.preventDefault();
          console.log('evt++++++++++++++++++++',evt);
          if(evt.submitter && evt.submitter.classList.contains('bundle_product_atc_btn')){
           const bundle_items = [];
           let variant_containors = document.querySelectorAll('.product__info-container variant-selects');
           variant_containors.forEach((variant_containor)=>{
             let first_selected_variant = variant_containor.querySelector('.bundle_product_input:checked');
             let bundle_product_inputs = variant_containor.querySelectorAll('.bundle_product_input');
             let sold_out_variants = variant_containor.querySelectorAll('.visually-disabled.bundle_product_input');
             if(!first_selected_variant && bundle_product_inputs.length != sold_out_variants.length){
               variant_containor.querySelector('.bundle_error_msg').classList.remove('hidden');
               variant_containor.querySelector('.bundle_error_msg').classList.add('show');
             }else{
               variant_containor.querySelector('.bundle_error_msg').classList.add('hidden');
               variant_containor.querySelector('.bundle_error_msg').classList.remove('show');
               if(first_selected_variant){
                bundle_items.push({
                  id: first_selected_variant.dataset.var_id,
                  quantity: 1,
                  properties: {
                  _bundle_product: true
                  }
                })
               }
             }
           })
           let first_error_msg = document.querySelector('.bundle_error_msg.show');
           if(first_error_msg){
            first_error_msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
           }
           if(bundle_items.length){
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner')?.classList.remove('hidden');
            
             try {
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    items: bundle_items
                  })
                });

                const data = await response.json();
                  this.submitButton.classList.remove('loading');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');
                // handleFloCartBtn();
              //  location.reload();
              // window.location.href = '/cart';
                slideShiprocketSmartCartInFrame();
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                soldOutMessage.classList.remove('hidden');
                soldOutMessage.classList.remove('hidden');    
              } catch (error) {
                console.error('Error adding bundle:', error);
              }
           }
          }else{
              if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

              this.handleErrorMessage();

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.classList.add('loading');
              this.querySelector('.loading__spinner')?.classList.remove('hidden');

              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              const formData = new FormData(this.form);
              // if (this.cart) {
              //   formData.append(
              //     'sections',
              //     this.cart.getSectionsToRender().map((section) => section.id)
              //   );
              //   formData.append('sections_url', window.location.pathname);
              //   this.cart.setActiveElement(document.activeElement);
              // }
              config.body = formData;

              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                  }

                  // Cart update logic commented out
                  // const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                  // if (!this.error)
                  //   publish(PUB_SUB_EVENTS.cartUpdate, {
                  //     source: 'product-form',
                  //     productVariantId: formData.get('id'),
                  //     cartData: response,
                  //   }).then(() => {
                  //     CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                  //   });

                  // const quickAddModal = this.closest('quick-add-modal');
                  // if (quickAddModal) {
                  //   document.body.addEventListener(
                  //     'modalClosed',
                  //     () => {
                  //       setTimeout(() => {
                  //         CartPerformance.measure("add:paint-updated-sections", () => {
                  //           this.cart.renderContents(response);
                  //         });
                  //       });
                  //     },
                  //     { once: true }
                  //   );
                  //   quickAddModal.hide(true);
                  // } else {
                  //   CartPerformance.measure("add:paint-updated-sections", () => {
                  //     this.cart.renderContents(response);
                  //   });
                  // }

                  this.error = false;

                  // ✅ Call handleFloCartBtn only after successful add
                  // handleFloCartBtn();
                  slideShiprocketSmartCartInFrame();
                  // location.reload();
                  // window.location.href = '/cart';
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');
                  // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');

                  CartPerformance.measureFromEvent("add:user-action", evt);
                });
        }
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
